import {
  RemoveLongTokenDurationSecure,
  SaveLongTokenDurationSecureType,
} from '@/types/security';
import { GetStorageItemType, SetStorageItemType } from '@/types/storage';
import {
  RestartInterface,
  RestartWithLogoutInterface,
} from '@/types/appManagement';
import { Security } from './security';
import { Storage } from './storage';
import {
  // APP_VERSION,
  BASE_API,
  MODULES_API,
} from '../environment';

export class AppManagement {
  // private static mayorVersion: string = APP_VERSION.split('.')[0];
  // private static mediumVersion: string = APP_VERSION.split('.')[1];
  // private static minorVersion: string = APP_VERSION.split('.')[2];
  private static buildNumber: string;
  private static deviceId: string;
  private static baseUrl: string = BASE_API!;
  private static moduleUrl: string = MODULES_API!;

  static operativeSystem: string;
  static restart: RestartInterface;
  static restartWithLogout: RestartWithLogoutInterface;

  static initApp = (
    restart: RestartInterface,
    restartWithLogout: RestartWithLogoutInterface,
    mayorVersion: string,
    mediumVersion: string,
    minorVersion: string,
    baseUrl: string,
    operativeSystem: string,
    buildNumber: string,
    deviceId: string,
    // TODO: check again after cookies is implemented
    saveLongTokenDurationSecure: SaveLongTokenDurationSecureType,
    removeLongTokenDurationSecure: RemoveLongTokenDurationSecure,
    getStorageItemType: GetStorageItemType,
    setStorageItemType: SetStorageItemType,
  ) => {
    AppManagement.restart = restart;
    AppManagement.operativeSystem = operativeSystem;
    AppManagement.restartWithLogout = restartWithLogout;
    // AppManagement.mayorVersion = mayorVersion;
    // AppManagement.mediumVersion = mediumVersion;
    // AppManagement.minorVersion = minorVersion;
    AppManagement.buildNumber = buildNumber;
    AppManagement.deviceId = deviceId;
    AppManagement.baseUrl = baseUrl;
    Security.init(saveLongTokenDurationSecure, removeLongTokenDurationSecure);
    Storage.init(getStorageItemType, setStorageItemType);
  };

  static setUrls = (baseUrl: string) => {
    AppManagement.baseUrl = baseUrl;
  };

  // static getVersion = () =>
  //   `${AppManagement.mayorVersion}.${AppManagement.mediumVersion}`;
  // static getMinorVersion = () => AppManagement.minorVersion;
  // static getMediumVersion = () => AppManagement.minorVersion;
  // static getMayorVersion = () => AppManagement.minorVersion;
  static getBuildNumber = () => AppManagement.buildNumber;
  static getDeviceId = () => AppManagement.deviceId;
  static getBaseUrl = () => AppManagement.baseUrl;
  static getModuleUrl = () => AppManagement.moduleUrl;
}
